<template>
  <div class="login">

    <div class="loading">
      <div class="loading-img">
        <img src="https://medin.oss-cn-shanghai.aliyuncs.com/file/images/cmhk/mylinkxiaolimao.gif" alt="loading">
      </div>
    </div>
  </div>
</template>

<script>
import { loginMyLink } from '@/js/axios'
import { Base64 } from 'js-base64';
import { Toast } from 'vant';
import { setToken } from '@/js/auth'



export default {
  name: 'myLinkLogin',

  data () {
    return {
      loading: true
    };
  },

  mounted () {


    const search = window.location.search;
    const params = new URLSearchParams(search);
    const thirdPartyToken = params.get('thirdPartyToken');
    if (thirdPartyToken) {
      const data = {
        thirdPartyToken
      }
      loginMyLink(data).then(res => {
        if (res.code === 200) {
          localStorage.setItem('thirdPartyToken', thirdPartyToken)
          const resData = JSON.parse(Base64.decode(res.data))
          if (resData.closeDate) {
            localStorage.setItem('closeDate', resData.closeDate)
          } else {
            localStorage.removeItem('closeDate')
          }
          setToken(resData.access_token)
          setTimeout(() => {
            this.$router.back()
          }, 1000)
        } else {
          localStorage.clear()
          this.$store.commit('checkLogin', false)
          localStorage.removeItem('closeDate')

          Toast.fail(res.msg)
        }
      })
    } else {
      localStorage.clear()
      Toast.fail('不存在合法的thirdPartyToken')
    }
  },

  methods: {

  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(180deg, #F1F5FF 0%, #FFFFFF 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: .24rem;

  >div {
    width: 100%;



  }



  .loading {
    width: 100%;
    padding: .48rem;
    display: flex;
    flex-direction: column;
    align-items: center;


    .loading-img {
      width: 3rem;

      >img {
        width: 100%;

      }
    }

    .loading-text {
      font-weight: 500;
      font-size: 0.28rem;
      color: #32363E;
      line-height: 0.34rem;
      letter-spacing: 1px;
      text-align: center;
      font-style: normal;
    }

  }

}
</style>